<h2>{{ album.name }}</h2>

<h3>
  Full track listings for {{ album.name }}
  <h3>Click the queue_music icon to add a song from your favourites list</h3>
</h3>

<mat-card>
  <mat-card-content fxLayout="row wrap" fxLayout.xs="column">
    <div fxflex>
      <img
        src="{{ album.images[0].url }}"
        alt="album cover"
        [style.margin]="'10px'"
        [style.max-width]="'30%'"
      />
      <div fxFlex>
        <div [style.min-width]="'300px'" [style.margin]="'10px'">
          <strong>Record Label: </strong>{{ album.label }} <br />
          <strong>Release Date: </strong> {{ album.release_date }}<br /><br />
          <strong>Tracks:</strong> {{ album.total_tracks }}<br />
          <strong>Popularity: </strong>{{ album.popularity }}<br /><br />

          <mat-chip-list aria-label="Artist selection">
            <a
              class="nav-link"
              routerLink="/artist/{{ album.artists[0].id }}"
              routerLinkActive="active"
              style="text-decoration: none"
            >
              <mat-chip>{{ album.artists[0].name }}</mat-chip>
            </a>
          </mat-chip-list>
          <br />

          <div>
            {{ album.copyrights[0].text }}
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<br /><br />
<h2>Track Listing</h2>

<mat-list>
  <!-- Single "Responsive" Material List Item-->
  <mat-list-item *ngFor="let track of tracks">
    <h1></h1>
    <mat-icon mat-list-icon (click)="addToFavourites(track.id)"
      >queue_music</mat-icon
    >
    <div mat-line>
      <mat-card>
        <mat-card-content>
          {{ track.track_number }}: {{ track.name }} -
          {{ convertTime(track.duration_ms) }}
          <br />
          <div *ngIf="track.preview_url">
            <audio controls [src]="track.preview_url"></audio>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-list-item>
  <!-- -->
</mat-list>
